---
seo:
  title: Tongue Tie
  description: configure your report settings
---

# **Tongue Tie**

- **Add/Edit/Hide** fields
  - These lists make up the **menu items** used on your **[Patient Report](/staff/managing-patients/reports/journey)**
- Visit our **[Knowledge Base](/staff/knowledge-base)** to see or use terminology that suits your needs


![throat](./assets/tongue-tie.png)